import styled from 'styled-components';

export const Container = styled.div`
  padding: 22px 26px 40px;
`;

export const PageHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;

  .ico {
    color: #1f5bc4;
    font-size: 18px;
    line-height: 1;
  }

  .page-title {
    font-size: 19px;
    font-weight: 700;
    color: #1f2430;
  }
`;

export const Breadcrumb = styled.div`
  font-size: 12.5px;
  color: #8b8d97;
  margin-bottom: 18px;
  margin-left: 28px;

  b {
    color: #55565c;
    font-weight: 600;
  }
`;

export const FilterCard = styled.div`
  background: #fff;
  border: 1px solid #e7e7e9;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: flex-end;

  .field {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .field label {
    font-size: 11.5px;
    color: #8b8d97;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .ant-input-affix-wrapper,
  .ant-picker {
    border: 1px solid #dcdde1;
    border-radius: 6px;
    background: #fbfbfc;
    min-width: 220px;
    height: 36px;
  }

  /* Keep the search button (lupa) the same height as the input */
  .ant-input-search .ant-input-search-button,
  .ant-input-group-addon .ant-btn {
    height: 36px;
  }

  /* Tenant Select (organism) alinhado ao label, mesma altura dos demais campos */
  .tenant-field .select,
  .tenant-field .list {
    margin-left: 0;
  }
  .tenant-field .select {
    min-height: 36px;
    box-shadow: none;
    border: 1px solid #dcdde1;
    background: #fbfbfc;
  }
`;

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
`;

export const SummaryCard = styled.div`
  background: #fff;
  border: 1px solid #e7e7e9;
  border-radius: 10px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .label {
    font-size: 11px;
    letter-spacing: 0.4px;
    color: #8b8d97;
    font-weight: 700;
    text-transform: uppercase;
  }
  .value {
    font-size: 24px;
    font-weight: 700;
    color: #1f5bc4;
  }
  .value.gray {
    color: #55565c;
    font-size: 19px;
  }
  .sub {
    font-size: 11.5px;
    color: #8b8d97;
  }
`;

export const TableCard = styled.div`
  background: #fff;
  border: 1px solid #e7e7e9;
  border-radius: 10px;
  overflow: hidden;

  .table-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    border-bottom: 1px solid #e7e7e9;
  }

  .table-card-head h3 {
    font-size: 14.5px;
    font-weight: 700;
    color: #1f2430;
    margin: 0;
  }

  .table-card-head .count {
    font-size: 12.5px;
    color: #8b8d97;
    margin-left: 8px;
    font-weight: 400;
  }

  .table-scroll {
    width: 100%;
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  thead th {
    text-align: left;
    font-size: 11px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: #8b8d97;
    font-weight: 700;
    padding: 10px 18px;
    border-bottom: 1px solid #e7e7e9;
    background: #fafafb;
    white-space: nowrap;
  }

  tbody td {
    padding: 12px 18px;
    border-bottom: 1px solid #f0f0f2;
    color: #2c2c2c;
    vertical-align: middle;
  }

  tbody tr:hover {
    background: #f8fafc;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .charger-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .charger-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .dot-green {
    background: #2fa84f;
  }
  .dot-gray {
    background: #9a9a9a;
  }
  .dot-amber {
    background: #e0951a;
  }
  .charger-name {
    font-weight: 600;
    color: #1f2430;
  }
  .charger-station {
    font-size: 11.5px;
    color: #8b8d97;
  }

  .baseline-tag {
    display: inline-block;
    margin-left: 8px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: #6b6d76;
    background: #eef0f2;
    padding: 2px 8px;
    border-radius: 20px;
    vertical-align: middle;
  }
  tr.baseline-row {
    background: #fcfcfd;
  }

  .version-tag {
    font-family: 'SFMono-Regular', Consolas, monospace;
    background: #f0f2f5;
    padding: 3px 8px;
    border-radius: 5px;
    font-size: 12px;
    color: #384156;
  }
  .version-dash {
    color: #8b8d97;
  }

  .restart-msg {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11.5px;
    font-weight: 700;
    color: #a86a0d;
    background: #fdf0dc;
    padding: 4px 10px;
    border-radius: 20px;
    white-space: nowrap;
  }

  .user-cell {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .user-chip {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #e6f0ff;
    color: #1f5bc4;
    font-size: 10.5px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .user-chip.system {
    background: #eef0f2;
    color: #6b6d76;
  }

  .table-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 18px 12px;
    font-size: 12.5px;
    color: #8b8d97;
  }

  .table-footer .pagination-container {
    margin-top: 6px;
  }
`;

export const EmptyWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 18px;
  color: #8b8d97;

  .ant-empty-description {
    color: #8b8d97;
    font-size: 13px;
  }
`;
